// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2asGe","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Bdfx"};